// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"297":"39a1418d","425":"ce840032"}[chunkId] + ".chunk.js";
};